export const selectPipelineFunnelData = (state) =>
  state.capture.pipelineFunnel.data;

export const selectPipelineFunnelLoading = (state) =>
  state.capture.pipelineFunnel.isLoading;

export const selectPipelineFunnelError = (state) =>
  state.capture.pipelineFunnel.error;
